import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default function WhyWamglammz() {
    return (
        <div className="font-sans text-gray-800">
            {/* NAVBAR */}
            <Navbar />
            <section className="bg-[#F5F9FF] py-20">
                <div className="max-w-6xl mx-auto px-6 md:px-12">

                    {/* HERO */}
                    <div className="text-center mx-auto">
                        <h1 className="text-[42px] md:text-[56px] font-bold text-[#2563EB]">
                            Why WamGlammz
                        </h1>

                        <p className="mt-6 text-gray-600 text-[15px] leading-[30px]">
                            WamGlammz is more than a beauty-service booking platform—it is a purpose-driven ecosystem built for freelancers, salons, studios, clients, and the community. Unlike traditional booking systems that focus only on appointments, WamGlammz focuses on opportunity, empowerment, and accessibility.
                        </p>
                    </div>

                    {/* SECTION CARDS */}
                    <div className="mt-16 grid md:grid-cols-2 gap-8">

                        {/* CARD */}
                        <div className="bg-white rounded-2xl p-8 shadow-[0_20px_40px_rgba(0,31,42,0.08)] hover:shadow-[0_25px_50px_rgba(0,31,42,0.12)] transition">

                            <h2 className="text-xl font-semibold text-[#2563EB] mb-4">
                                1. Built for Both Freelancers & Salons
                            </h2>

                            <p className="text-gray-600 leading-[26px]">
                                Most booking platforms favor either independent artists or established salons.
                            </p>

                            <ul className="mt-4 space-y-2 text-gray-600 text-sm">
                                <li>• Freelance makeup artists</li>
                                <li>• Hair stylists</li>
                                <li>• Nail techs</li>
                                <li>• Estheticians</li>
                                <li>• Salons & studios</li>
                                <li>• Photographers & creators</li>
                            </ul>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-2xl p-8 shadow-[0_20px_40px_rgba(0,31,42,0.08)] hover:shadow-[0_25px_50px_rgba(0,31,42,0.12)] transition">

                            <h2 className="text-xl font-semibold text-[#2563EB] mb-4">
                                2. Mobile & On-Location Flexibility
                            </h2>

                            <ul className="space-y-2 text-gray-600 text-sm">
                                <li>• At home</li>
                                <li>• At salon</li>
                                <li>• At studio</li>
                                <li>• Events & weddings</li>
                                <li>• Travel bookings</li>
                            </ul>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-2xl p-8 shadow-[0_20px_40px_rgba(0,31,42,0.08)] hover:shadow-[0_25px_50px_rgba(0,31,42,0.12)] transition">

                            <h2 className="text-xl font-semibold text-[#2563EB] mb-4">
                                3. Supporting the Community
                            </h2>

                            <ul className="space-y-2 text-gray-600 text-sm">
                                <li>• Uplifting small businesses</li>
                                <li>• Opportunities for new artists</li>
                                <li>• Visibility for local talent</li>
                                <li>• Accessible services</li>
                                <li>• Community partnerships</li>
                            </ul>

                        </div>

                        {/* CARD */}
                        <div className="bg-white rounded-2xl p-8 shadow-[0_20px_40px_rgba(0,31,42,0.08)] hover:shadow-[0_25px_50px_rgba(0,31,42,0.12)] transition">

                            <h2 className="text-xl font-semibold text-[#2563EB] mb-4">
                                4. Smart Technology
                            </h2>

                            <ul className="space-y-2 text-gray-600 text-sm">
                                <li>• Smart booking</li>
                                <li>• Instant confirmations</li>
                                <li>• Secure payments</li>
                                <li>• Reviews & ratings</li>
                                <li>• Easy scheduling</li>
                            </ul>

                        </div>

                    </div>

                </div>

            </section>
            {/* <div className="text-center">
                <div className="flex justify-center">
                    <div className="w-[100%] h-[10px] bg-gradient-to-r from-transparent via-blue-400 to-transparent" />
                </div>
            </div> */}
            <div className="relative">
                <div className="h-20 bg-gradient-to-b from-transparent to-[#F5F9FF]" />
                <div className="flex justify-center">
                    <div className="w-[60%] h-[1px] bg-gradient-to-r from-transparent via-blue-300 to-transparent" />
                </div>
            </div>
            {/* FOOTER */}
            <Footer />
        </div>
    );
}